import {Component} from '@angular/core';

@Component({
  selector: 'digires-data-protection-dialog',
  templateUrl: './data-protection-dialog.component.html',
  styleUrls: ['./data-protection-dialog.component.scss']
})
export class DataProtectionDialogComponent {}
